import { WidgetContainer } from '@/components/analytics/WidgetContainer';
import type { SessionCompletionData } from '@/types/analytics';
import styles from './SessionCompletionRateWidget.module.scss';

export interface SessionCompletionRateWidgetProps {
    data: SessionCompletionData | null;
    isLoading?: boolean;
    error?: Error | null;
}

export function SessionCompletionRateWidget({ data, isLoading, error }: SessionCompletionRateWidgetProps) {
    const completionRate = data?.completionRate || 0;

    return (
        <WidgetContainer
            title="Completion Rate"
            description="Percentage of started sessions completed"
            isLoading={isLoading}
            error={error}
            size="small"
        >
            <div className={styles.container}>
                <div className={styles.metric}>
                    <span className={styles.value}>{Math.round(completionRate)}%</span>
                    <span className={styles.label}>Sessions Completed</span>
                </div>
                <div className={styles.progressContainer}>
                    <div className={styles.progressBar} style={{ width: `${Math.min(completionRate, 100)}%` }} />
                </div>
                <div className={styles.stats}>
                    <span>Started: {data?.started || 0}</span>
                    <span>Completed: {data?.completed || 0}</span>
                </div>
            </div>
        </WidgetContainer>
    );
}
